module.exports = __webpack_public_path__ + "img/room-carousel-4.03d828c4.jpg";